import React from 'react';
import { FilteredActionList as FilteredActionList$2 } from './FilteredActionListWithDeprecatedActionList.js';
import { FilteredActionList as FilteredActionList$1 } from './FilteredActionListWithModernActionList.js';
import '../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import '../FeatureFlags/DefaultFeatureFlags.js';

function FilteredActionList(props) {
  const enabled = useFeatureFlag('primer_react_select_panel_with_modern_action_list');
  if (enabled) return /*#__PURE__*/React.createElement(FilteredActionList$1, props);else return /*#__PURE__*/React.createElement(FilteredActionList$2, props);
}
FilteredActionList.displayName = 'FilteredActionList';

export { FilteredActionList };
